import { EntityFieldInfo } from '@record-it-npm/synchro-common';
import { EntityManagerBaseEntity } from '../EntityManagerBaseEntity';
import { AnySynchronizationEnvironmentTypesConstraint } from '../SynchronizationEnvironmentTypes';
export class EntityManagerFieldInfos {
  private constructor() {}
  public static createAdditionalFieldInfos<TSynchronizationEnvironmentTypes extends AnySynchronizationEnvironmentTypesConstraint>(): BaseFieldInfos<TSynchronizationEnvironmentTypes> {
    return {
      revision: {
        name: 'revision',
        defaultValue: 0
      },
      deleted: {
        name: 'deleted',
        defaultValue: false
      },
      deletedAt: {
        name: 'deletedAt',
        defaultValue: null
      },
      originalIds: {
        name: 'originalIds',
        defaultValue: () => []
      },
      onlyLocal: {
        name: 'onlyLocal',
        defaultValue: false
      },
      readyToSynchronize: {
        name: 'readyToSynchronize',
        defaultValue: true
      },
      shadowEntity: {
        name: 'shadowEntity',
        defaultValue: false
      },
      temporaryGroupName: {
        name: 'temporaryGroupName',
        defaultValue: null
      }
    };
  }
}
export type BaseFieldInfos<TSynchronizationEnvironmentTypes extends AnySynchronizationEnvironmentTypesConstraint> = {
  revision: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'revision'>;
  deleted: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'deleted'>;
  deletedAt: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'deletedAt'>;
  originalIds: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'originalIds'>;
  onlyLocal: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'onlyLocal'>;
  readyToSynchronize: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'readyToSynchronize'>;
  shadowEntity: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'shadowEntity'>;
  temporaryGroupName: EntityFieldInfo<TSynchronizationEnvironmentTypes['CommonSynchronizationEnvironmentTypes'], EntityManagerBaseEntity, 'temporaryGroupName'>;
};